module.exports = __webpack_public_path__ + "img/white-yellow.6b4f228c.png";